// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/rubik-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/rubik-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/rubik-medium-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/rubik-medium-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/rubik-bold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/rubik-bold-webfont.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
  font-weight: bold;
  font-style: normal;
}

:root {
  --bg: #E5E5E5;
  --bg-2: #FAFAFA;
  --bg-3: #A3A3A3;
  --fg: #171717;
  --fg-2: #404040;
  --red: #FCA5A5;
  --gold: #FDBA74;
  --svg-width-sidebar: 25px;
}

* {
  box-sizing: border-box;
}

body {
  padding: 0;
  margin: 0;
  font-family: "Rubik";
  min-height: 100vh;
  background: var(--bg);
  color: var(--fg);

  display: grid;
  grid-template-columns: 1fr 4.5fr;
}

button,
input {
  font-family: inherit;
}

button {
  all: unset;
  text-align: center;
  box-sizing: border-box;
}

button:hover {
  cursor: pointer;
}

svg {
  pointer-events: none;
}

.sidebar {
  background: var(--bg-2);
  padding: 1.5rem;

  .logo-container {
    display: flex;
    align-items: baseline;
    gap: .75rem;

    h1 {
      font-size: 1.75rem;
      margin-bottom: 0;
    }

    svg {
      fill: var(--red);
      width: 40px;
    }
  }

  .task-bar {

    .add-task-btn {
      width: 100%;
      font-weight: 500;
      background: var(--bg);
      padding: 0 10px;
      border-radius: 10px;

      display: flex;
      align-items: center;
      gap: .5rem;

      &:hover {
        outline: 3px solid var(--bg-3);
      }

      svg {
        fill: var(--red);
        width: var(--svg-width-sidebar);
      }
    }

    .task-grouping {
      margin: .5rem 0;

      display: flex;
      flex-direction: column;
      gap: .2rem;

      button {
        width: 100%;
        padding: 0 10px;
        padding-right: 20px;
        border-radius: 10px;

        display: flex;
        justify-content: space-between;
        gap: 2rem;

        &:hover {
          background: var(--bg);
        }

        div {
          display: flex;
          align-items: center;
          gap: .4rem;
        }

        svg {
          fill: var(--bg-3);
          width: var(--svg-width-sidebar);
        }

        >p:last-child {
          color: var(--bg-3);
        }
      }
    }
  }

  .list-bar {
    svg {
      fill: var(--bg-3);
      width: var(--svg-width-sidebar);
    }

    h3 {
      font-weight: 500;
      font-size: 1.3rem;
      color: var(--fg-2);
    }

    .list-empty-warning {
      font-size: .9rem;
      color: var(--bg-3);
    }

    .add-list-form,
    .rename-list-form {
      padding: 10px;

      display: grid;
      grid-template-columns: auto auto;
      gap: .75rem;

      input {
        grid-column: 1 / 3;
        height: 2rem;
        font-size: 1rem;
        border: none;
        outline: 2px solid var(--bg);
        border-radius: 3px;
        padding-left: 3px;
      }

      button {
        background: var(--bg);
        height: 2rem;
        border-radius: 3px;

        &:hover {
          outline: 2px solid var(--bg-3);
        }
      }
    }

    .lists {
      display: flex;
      flex-direction: column;
      gap: .3rem;

      .list {
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        gap: 2rem;

        border-radius: 10px;

        &:hover {
          background: var(--bg)
        }

        >div {
          display: flex;
          align-items: center;
          gap: .3rem;
        }

        >div:last-child>span:hover {
          svg {
            fill: var(--fg-2);
          }
        }
      }
    }

    .add-list-btn {
      margin-top: .5rem;
      width: 100%;
      padding: 5px;
      background: var(--bg);
      border-radius: 10px;

      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        outline: 3px solid var(--bg-3);
      }

      svg {
        width: 32px;
        fill: var(--fg-2);
      }
    }
  }

  hr {
    margin: 1rem 0;
    border: none;
    height: 3px;
    background: var(--bg);
  }
}

.selected {
  background: var(--bg);
}

main {
  display: flex;
  justify-content: center;

  >div {
    margin-top: 1rem;
    width: 70%;
  }

  hr {
    border: none;
    height: 1px;
    background: var(--bg-3);
  }

  div:has(>.task) {
    display: flex;
    flex-direction: column;
    gap: .5rem;
  }

  .task {
    display: flex;
    gap: 1rem;

    background: var(--bg-2);
    border-radius: 5px;
    padding-left: 1rem;
    outline: 1px solid var(--bg-3);

    input {
      transform: scale(1.4);
    }

    div:has(>.task-desc) {
      display: grid;
      grid-template-columns: minmax(auto, 65%) 15% 20%;
      align-items: center;
      gap: 1rem;

      width: 100%;
      padding-right: 3%;
      color: var(--fg-2);
      font-size: .95rem;

      >div:nth-last-child(2) {
        text-decoration: underline;

        &:hover {
          cursor: pointer;
          font-size: .96rem;
        }
      }

      >div:last-child {
        flex-shrink: 0;
      }
    }

    .task-desc {

      >p:first-child {
        font-weight: 500;
        text-decoration: underline;
        text-decoration-color: var(--bg-3);
        margin-bottom: 0;
        color: var(--fg);
        font-size: initial;
      }

      >p:nth-child(2) {
        font-size: .9rem;
        color: var(--fg-2);
      }

      &:hover {
        cursor: pointer;

        >p:first-child {
          text-decoration-color: var(--fg-2);
        }
      }
    }

    &.high {
      border-right: 10px solid var(--red);
    }

    &.medium {
      border-right: 10px solid var(--gold);
    }

    &.low {
      border-right: 10px solid var(--bg-3);
    }
  }

}

#addTaskModal,
#editTaskModal {
  background: var(--bg-2);
  border: 3px solid var(--bg-3);
  border-radius: 10px;
  width: max(500px, 40%);

  display: flex;
  justify-content: center;

  form {
    display: flex;
    flex-direction: column;

    gap: 1rem;
    width: 70%;

    padding: 1rem;

    h2 {
      margin: 0;
      margin-bottom: 1rem;
      text-align: center;
    }

    >div {
      display: flex;
      flex-direction: column;
      gap: .5rem;
    }

    >div:has(>button) {
      display: flex;
      flex-direction: row;
      margin-top: 1rem;
      margin-bottom: 1rem;

      button {
        width: 100%;
        padding: 1rem;
        background: var(--bg);
        border-radius: 10px;

        &:hover {
          outline: 3px solid var(--bg-3);
        }
      }
    }

    input,
    select {
      height: 2rem;
      font-size: 1rem;
      border: none;
      outline: 2px solid var(--bg-3);
      border-radius: 3px;
      padding-left: 10px;
      padding-right: 10px;
      font-family: inherit;
    }

    textarea {
      height: 5rem;
      font-size: 1rem;
      border: none;
      outline: 2px solid var(--bg-3);
      border-radius: 3px;
      padding-left: 3px;
      font-family: inherit;
      padding: 5px 10px;
    }
  }
}


@media only screen and (max-width: 600px) {
  body {
    grid-template-columns: unset;
  }

  main>div {
    width: 90%;
  }

  #addTaskModal,
  #editTaskModal {
    >form {
      width: 90%;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB;0DACiE;EACjE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;0DACgE;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;0DAC8D;EAC9D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;;EAEhB,aAAa;EACb,gCAAgC;AAClC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,eAAe;;EAEf;IACE,aAAa;IACb,qBAAqB;IACrB,WAAW;;IAEX;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,WAAW;IACb;EACF;;EAEA;;IAEE;MACE,WAAW;MACX,gBAAgB;MAChB,qBAAqB;MACrB,eAAe;MACf,mBAAmB;;MAEnB,aAAa;MACb,mBAAmB;MACnB,UAAU;;MAEV;QACE,8BAA8B;MAChC;;MAEA;QACE,gBAAgB;QAChB,+BAA+B;MACjC;IACF;;IAEA;MACE,eAAe;;MAEf,aAAa;MACb,sBAAsB;MACtB,UAAU;;MAEV;QACE,WAAW;QACX,eAAe;QACf,mBAAmB;QACnB,mBAAmB;;QAEnB,aAAa;QACb,8BAA8B;QAC9B,SAAS;;QAET;UACE,qBAAqB;QACvB;;QAEA;UACE,aAAa;UACb,mBAAmB;UACnB,UAAU;QACZ;;QAEA;UACE,iBAAiB;UACjB,+BAA+B;QACjC;;QAEA;UACE,kBAAkB;QACpB;MACF;IACF;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,+BAA+B;IACjC;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;;MAEE,aAAa;;MAEb,aAAa;MACb,gCAAgC;MAChC,WAAW;;MAEX;QACE,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,YAAY;QACZ,4BAA4B;QAC5B,kBAAkB;QAClB,iBAAiB;MACnB;;MAEA;QACE,qBAAqB;QACrB,YAAY;QACZ,kBAAkB;;QAElB;UACE,8BAA8B;QAChC;MACF;IACF;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,UAAU;;MAEV;QACE,eAAe;QACf,aAAa;QACb,8BAA8B;QAC9B,SAAS;;QAET,mBAAmB;;QAEnB;UACE;QACF;;QAEA;UACE,aAAa;UACb,mBAAmB;UACnB,UAAU;QACZ;;QAEA;UACE;YACE,iBAAiB;UACnB;QACF;MACF;IACF;;IAEA;MACE,iBAAiB;MACjB,WAAW;MACX,YAAY;MACZ,qBAAqB;MACrB,mBAAmB;;MAEnB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;;MAEnB;QACE,8BAA8B;MAChC;;MAEA;QACE,WAAW;QACX,iBAAiB;MACnB;IACF;EACF;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,qBAAqB;EACvB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;;EAEvB;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,SAAS;;IAET,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;;IAE9B;MACE,qBAAqB;IACvB;;IAEA;MACE,aAAa;MACb,gDAAgD;MAChD,mBAAmB;MACnB,SAAS;;MAET,WAAW;MACX,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;;MAEjB;QACE,0BAA0B;;QAE1B;UACE,eAAe;UACf,iBAAiB;QACnB;MACF;;MAEA;QACE,cAAc;MAChB;IACF;;IAEA;;MAEE;QACE,gBAAgB;QAChB,0BAA0B;QAC1B,kCAAkC;QAClC,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;MACpB;;MAEA;QACE,gBAAgB;QAChB,kBAAkB;MACpB;;MAEA;QACE,eAAe;;QAEf;UACE,kCAAkC;QACpC;MACF;IACF;;IAEA;MACE,mCAAmC;IACrC;;IAEA;MACE,oCAAoC;IACtC;;IAEA;MACE,oCAAoC;IACtC;EACF;;AAEF;;AAEA;;EAEE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;;EAEtB,aAAa;EACb,uBAAuB;;EAEvB;IACE,aAAa;IACb,sBAAsB;;IAEtB,SAAS;IACT,UAAU;;IAEV,aAAa;;IAEb;MACE,SAAS;MACT,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,UAAU;IACZ;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;;MAEnB;QACE,WAAW;QACX,aAAa;QACb,qBAAqB;QACrB,mBAAmB;;QAEnB;UACE,8BAA8B;QAChC;MACF;IACF;;IAEA;;MAEE,YAAY;MACZ,eAAe;MACf,YAAY;MACZ,8BAA8B;MAC9B,kBAAkB;MAClB,kBAAkB;MAClB,mBAAmB;MACnB,oBAAoB;IACtB;;IAEA;MACE,YAAY;MACZ,eAAe;MACf,YAAY;MACZ,8BAA8B;MAC9B,kBAAkB;MAClB,iBAAiB;MACjB,oBAAoB;MACpB,iBAAiB;IACnB;EACF;AACF;;;AAGA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE;MACE,UAAU;IACZ;EACF;AACF","sourcesContent":["@font-face {\n  font-family: 'Rubik';\n  src: url('./assets/fonts/rubik-regular-webfont.woff2') format('woff2'),\n    url('./assets/fonts/rubik-regular-webfont.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Rubik';\n  src: url('./assets/fonts/rubik-medium-webfont.woff2') format('woff2'),\n    url('./assets/fonts/rubik-medium-webfont.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Rubik';\n  src: url('./assets/fonts/rubik-bold-webfont.woff2') format('woff2'),\n    url('./assets/fonts/rubik-bold-webfont.woff') format('woff');\n  font-weight: bold;\n  font-style: normal;\n}\n\n:root {\n  --bg: #E5E5E5;\n  --bg-2: #FAFAFA;\n  --bg-3: #A3A3A3;\n  --fg: #171717;\n  --fg-2: #404040;\n  --red: #FCA5A5;\n  --gold: #FDBA74;\n  --svg-width-sidebar: 25px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  font-family: \"Rubik\";\n  min-height: 100vh;\n  background: var(--bg);\n  color: var(--fg);\n\n  display: grid;\n  grid-template-columns: 1fr 4.5fr;\n}\n\nbutton,\ninput {\n  font-family: inherit;\n}\n\nbutton {\n  all: unset;\n  text-align: center;\n  box-sizing: border-box;\n}\n\nbutton:hover {\n  cursor: pointer;\n}\n\nsvg {\n  pointer-events: none;\n}\n\n.sidebar {\n  background: var(--bg-2);\n  padding: 1.5rem;\n\n  .logo-container {\n    display: flex;\n    align-items: baseline;\n    gap: .75rem;\n\n    h1 {\n      font-size: 1.75rem;\n      margin-bottom: 0;\n    }\n\n    svg {\n      fill: var(--red);\n      width: 40px;\n    }\n  }\n\n  .task-bar {\n\n    .add-task-btn {\n      width: 100%;\n      font-weight: 500;\n      background: var(--bg);\n      padding: 0 10px;\n      border-radius: 10px;\n\n      display: flex;\n      align-items: center;\n      gap: .5rem;\n\n      &:hover {\n        outline: 3px solid var(--bg-3);\n      }\n\n      svg {\n        fill: var(--red);\n        width: var(--svg-width-sidebar);\n      }\n    }\n\n    .task-grouping {\n      margin: .5rem 0;\n\n      display: flex;\n      flex-direction: column;\n      gap: .2rem;\n\n      button {\n        width: 100%;\n        padding: 0 10px;\n        padding-right: 20px;\n        border-radius: 10px;\n\n        display: flex;\n        justify-content: space-between;\n        gap: 2rem;\n\n        &:hover {\n          background: var(--bg);\n        }\n\n        div {\n          display: flex;\n          align-items: center;\n          gap: .4rem;\n        }\n\n        svg {\n          fill: var(--bg-3);\n          width: var(--svg-width-sidebar);\n        }\n\n        >p:last-child {\n          color: var(--bg-3);\n        }\n      }\n    }\n  }\n\n  .list-bar {\n    svg {\n      fill: var(--bg-3);\n      width: var(--svg-width-sidebar);\n    }\n\n    h3 {\n      font-weight: 500;\n      font-size: 1.3rem;\n      color: var(--fg-2);\n    }\n\n    .list-empty-warning {\n      font-size: .9rem;\n      color: var(--bg-3);\n    }\n\n    .add-list-form,\n    .rename-list-form {\n      padding: 10px;\n\n      display: grid;\n      grid-template-columns: auto auto;\n      gap: .75rem;\n\n      input {\n        grid-column: 1 / 3;\n        height: 2rem;\n        font-size: 1rem;\n        border: none;\n        outline: 2px solid var(--bg);\n        border-radius: 3px;\n        padding-left: 3px;\n      }\n\n      button {\n        background: var(--bg);\n        height: 2rem;\n        border-radius: 3px;\n\n        &:hover {\n          outline: 2px solid var(--bg-3);\n        }\n      }\n    }\n\n    .lists {\n      display: flex;\n      flex-direction: column;\n      gap: .3rem;\n\n      .list {\n        padding: 0 10px;\n        display: flex;\n        justify-content: space-between;\n        gap: 2rem;\n\n        border-radius: 10px;\n\n        &:hover {\n          background: var(--bg)\n        }\n\n        >div {\n          display: flex;\n          align-items: center;\n          gap: .3rem;\n        }\n\n        >div:last-child>span:hover {\n          svg {\n            fill: var(--fg-2);\n          }\n        }\n      }\n    }\n\n    .add-list-btn {\n      margin-top: .5rem;\n      width: 100%;\n      padding: 5px;\n      background: var(--bg);\n      border-radius: 10px;\n\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      &:hover {\n        outline: 3px solid var(--bg-3);\n      }\n\n      svg {\n        width: 32px;\n        fill: var(--fg-2);\n      }\n    }\n  }\n\n  hr {\n    margin: 1rem 0;\n    border: none;\n    height: 3px;\n    background: var(--bg);\n  }\n}\n\n.selected {\n  background: var(--bg);\n}\n\nmain {\n  display: flex;\n  justify-content: center;\n\n  >div {\n    margin-top: 1rem;\n    width: 70%;\n  }\n\n  hr {\n    border: none;\n    height: 1px;\n    background: var(--bg-3);\n  }\n\n  div:has(>.task) {\n    display: flex;\n    flex-direction: column;\n    gap: .5rem;\n  }\n\n  .task {\n    display: flex;\n    gap: 1rem;\n\n    background: var(--bg-2);\n    border-radius: 5px;\n    padding-left: 1rem;\n    outline: 1px solid var(--bg-3);\n\n    input {\n      transform: scale(1.4);\n    }\n\n    div:has(>.task-desc) {\n      display: grid;\n      grid-template-columns: minmax(auto, 65%) 15% 20%;\n      align-items: center;\n      gap: 1rem;\n\n      width: 100%;\n      padding-right: 3%;\n      color: var(--fg-2);\n      font-size: .95rem;\n\n      >div:nth-last-child(2) {\n        text-decoration: underline;\n\n        &:hover {\n          cursor: pointer;\n          font-size: .96rem;\n        }\n      }\n\n      >div:last-child {\n        flex-shrink: 0;\n      }\n    }\n\n    .task-desc {\n\n      >p:first-child {\n        font-weight: 500;\n        text-decoration: underline;\n        text-decoration-color: var(--bg-3);\n        margin-bottom: 0;\n        color: var(--fg);\n        font-size: initial;\n      }\n\n      >p:nth-child(2) {\n        font-size: .9rem;\n        color: var(--fg-2);\n      }\n\n      &:hover {\n        cursor: pointer;\n\n        >p:first-child {\n          text-decoration-color: var(--fg-2);\n        }\n      }\n    }\n\n    &.high {\n      border-right: 10px solid var(--red);\n    }\n\n    &.medium {\n      border-right: 10px solid var(--gold);\n    }\n\n    &.low {\n      border-right: 10px solid var(--bg-3);\n    }\n  }\n\n}\n\n#addTaskModal,\n#editTaskModal {\n  background: var(--bg-2);\n  border: 3px solid var(--bg-3);\n  border-radius: 10px;\n  width: max(500px, 40%);\n\n  display: flex;\n  justify-content: center;\n\n  form {\n    display: flex;\n    flex-direction: column;\n\n    gap: 1rem;\n    width: 70%;\n\n    padding: 1rem;\n\n    h2 {\n      margin: 0;\n      margin-bottom: 1rem;\n      text-align: center;\n    }\n\n    >div {\n      display: flex;\n      flex-direction: column;\n      gap: .5rem;\n    }\n\n    >div:has(>button) {\n      display: flex;\n      flex-direction: row;\n      margin-top: 1rem;\n      margin-bottom: 1rem;\n\n      button {\n        width: 100%;\n        padding: 1rem;\n        background: var(--bg);\n        border-radius: 10px;\n\n        &:hover {\n          outline: 3px solid var(--bg-3);\n        }\n      }\n    }\n\n    input,\n    select {\n      height: 2rem;\n      font-size: 1rem;\n      border: none;\n      outline: 2px solid var(--bg-3);\n      border-radius: 3px;\n      padding-left: 10px;\n      padding-right: 10px;\n      font-family: inherit;\n    }\n\n    textarea {\n      height: 5rem;\n      font-size: 1rem;\n      border: none;\n      outline: 2px solid var(--bg-3);\n      border-radius: 3px;\n      padding-left: 3px;\n      font-family: inherit;\n      padding: 5px 10px;\n    }\n  }\n}\n\n\n@media only screen and (max-width: 600px) {\n  body {\n    grid-template-columns: unset;\n  }\n\n  main>div {\n    width: 90%;\n  }\n\n  #addTaskModal,\n  #editTaskModal {\n    >form {\n      width: 90%;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
